import { config } from '../../config'

const { STAGE } = config
export const delayMs = (timeout: number, testTimeout = 100) => (STAGE === 'test' ? testTimeout : timeout)
